import { de } from '@/i18n/de';
import { Sheet } from '@/components/Sheet';
import { Button } from '@/components/Button';

interface ConfirmSheetProps {
  open: boolean;
  title: string;
  /** Was die Bestätigung auslöst — bewusst als eigener Satz, nicht als Titelanhang. */
  body?: string;
  confirmLabel: string;
  /** Setzt den Bestätigen-Button auf Outline statt Gold (GDD §33: kein rotes Füllen). */
  destructive?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Rückfrage im Design der App statt `window.confirm`.
 *
 * Keine eigene Dialog-Mechanik: das vorhandene `Sheet` bringt Overlay, Fokus
 * und Schließen-Geste bereits mit — hier kommt nur der Inhalt dazu.
 */
export function ConfirmSheet({
  open,
  title,
  body,
  confirmLabel,
  destructive = false,
  onConfirm,
  onCancel,
}: ConfirmSheetProps) {
  return (
    <Sheet open={open} onClose={onCancel} title={title}>
      <div className="flex flex-col gap-4">
        {body && <p className="text-sm text-fg-muted">{body}</p>}
        <div className="flex flex-col gap-2 sm:flex-row-reverse">
          <Button fullWidth variant={destructive ? 'danger-outline' : 'primary'} onClick={onConfirm}>
            {confirmLabel}
          </Button>
          <Button fullWidth variant="ghost" onClick={onCancel}>
            {de.common.cancel}
          </Button>
        </div>
      </div>
    </Sheet>
  );
}
